import { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { UtagContext } from '../../context/UtagContext';
import './tab-header.scss';
import { callFunctionDkView, callGTMAnalytics } from '../../helper/analyticsTag';
import { useRecoilState } from 'recoil';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';

type TabSelected = {
  tabId: (currentTab: string) => void;
  tabProp: string;
  isHasMyList: boolean;
};
const TabHeader: React.FC<TabSelected> = (props) => {
  // ! for language
  const { t } = useTranslation();
  const [utagData] = useRecoilState(utagObjectAtom);
  const tabs = [
    {
      id: 'tabCompareAtt',
      tabTitle: t('xref-introduction-compare'),
      tabContent: 'Compare'
    },
    {
      id: 'tabBasePart',
      tabTitle: t('xref-search-ctr-base-parts'),
      tabContent: 'Base Parts'
    },
    {
      id: 'tabComparePinouts',
      tabTitle: t('xref-search-ctr-pinouts'),
      tabContent: 'Pinouts'
    },

    {
      id: 'tabReverseLookup',
      tabTitle: t('xref-search-ctr-revers-lookup'),
      tabContent: 'Reverse Lookup'
    }
  ];
  const [currentTab, setCurrentTab] = useState<string>('tabCompareAtt');
  const utagContext = useContext(UtagContext);

  const handleTabClick = (e: any) => {
    setCurrentTab(e.target.id);
    let tabSelectBtn =
      document
        .querySelector(`[id=${e.target.id}]`)
        ?.getAttribute('ref_page_event') ?? '';
    if (tabSelectBtn) {
      utagContext.setRef(tabSelectBtn);
      callGTMAnalytics(utagData, tabSelectBtn);
      callFunctionDkView({...utagData,...{ref_page_event:tabSelectBtn}});
    }
    props.tabId(e.target.id);
  };

  useEffect(() => {
    if (props.tabProp) setCurrentTab(props.tabProp);
  }, [props.tabProp, props.isHasMyList]);
  return (
    <>
      <div className="tab-container">
        <ul className="list-tab d-flex justify-content-between">
          {tabs.map((tab, i) => (
            <li
              key={i}
              id={tab.id}
              {...{ ref_page_event: tab.tabContent }}
              className={
                ' tab-child box-shadow-none ' +
                (currentTab === `${tab.id}` ? 'active-tab-compare' : '') +
                (props.isHasMyList && tab.id !== 'tabCompareAtt' && tab.id !== 'tabReverseLookup' ? ' disable-tab' : '')
              }
              onClick={handleTabClick}
            >
              {tab.tabTitle}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
export default TabHeader;
